import {Status} from "@ampeco/charge-models";
import net from '@ampeco/net'

export async function getStatus(): Promise<Status> {
    return (await net.get('/app/status')) as Status;
}
